'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const tslib_es6 = require('../../../tslib.es6-CZ43up4V.js');
const React = require('react');
const components_forms_BooleanInput_LabeledBooleanInput = require('./LabeledBooleanInput.cjs.js');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const LabeledRadio = (_a) => {
  var { disabled, isDisabled } = _a, props = tslib_es6.__rest(_a, ["disabled", "isDisabled"]);
  return React__default.default.createElement(components_forms_BooleanInput_LabeledBooleanInput.LabeledBooleanInput, Object.assign({}, props, { isDisabled: disabled || isDisabled, type: "radio" }));
};

exports.LabeledRadio = LabeledRadio;
//# sourceMappingURL=LabeledRadio.cjs.js.map
